var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 487.4135 561.5647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ad1a6be5-80a7-4fd6-96f5-197b97a6cc79",
    transform: "translate(-3.5865 62.7579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.1859,145.189H429.0393a61.9607,61.9607,0,0,0,0-123.9214H247.1859a61.9607,61.9607,0,1,0,0,123.9214Z",
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e6f5d0d2-f9bc-4861-b6bc-898f5dd78963",
    x1: 24.7638,
    y1: 270.4085,
    x2: 414.8352,
    y2: 270.4085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#deebff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#deebff",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#deebff",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#deebff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#deebff",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deebff",
    stopOpacity: 0.3
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b0bf78b8-af59-4e2f-8d14-134729af7cfa",
    x1: 3991.2375,
    y1: -2540.4533,
    x2: 3991.2375,
    y2: -2717.2334,
    gradientTransform: "translate(4096.0823 -2348.776) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe380"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fac926af-2a44-4a9b-bdec-b860ad2f5d66",
    x1: 81.6163,
    y1: 1124.5412,
    x2: 187.2244,
    y2: 1124.5412,
    gradientTransform: "translate(-3.5865 -588.2421)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#091e42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#091e42",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#091e42",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#091e42",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#091e42",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091e42",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b03a9b0c-b263-49a5-aaa9-45385bea17ab",
    x1: -917.6128,
    y1: 1026.3162,
    x2: -871.5087,
    y2: 1026.3162,
    gradientTransform: "matrix(-1, 0, 0, 1, -788, -651)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0049b0"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bbe26835-66db-4318-9601-eb6f885c3df4",
    x1: 370.6877,
    y1: 1139.6023,
    x2: 476.2958,
    y2: 1139.6023,
    xlinkHref: "#fac926af-2a44-4a9b-bdec-b860ad2f5d66"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f3c99759-2acd-44d1-9c2c-50366d998842",
    x1: 411.1404,
    y1: 812.4243,
    x2: 428.7404,
    y2: 794.8243,
    gradientTransform: "translate(-3.5865 -588.2421)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#0049b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0551bb",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1d76ec",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#2684ff",
    stopOpacity: 0.9
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f9bf74a5-47fb-46c2-82a4-b5cd40128223",
    x1: 51.4135,
    y1: 172.2579,
    x2: 80.4135,
    y2: 172.2579,
    xlinkHref: "#e6f5d0d2-f9bc-4861-b6bc-898f5dd78963"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af8bb7c0-75d1-443e-bf15-5ca0edf77010",
    x1: 97.4135,
    y1: 145.7579,
    x2: 116.4135,
    y2: 145.7579,
    xlinkHref: "#e6f5d0d2-f9bc-4861-b6bc-898f5dd78963"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a7f7e274-1885-4193-80c8-a4f18caf30d5",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eaca0b56-ecc8-44f2-9b2d-7aae7d2b3c8b",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#ad1a6be5-80a7-4fd6-96f5-197b97a6cc79)"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 243.5994,
    cy: 145.9862,
    r: 145.9863,
    style: {
      fill: "#fff",
      opacity: 0.100000001490116
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.5994,
    cy: 145.9862,
    r: 114.16,
    style: {
      fill: "#fff",
      opacity: 0.100000001490116
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.5994,
    cy: 145.9862,
    r: 82.3336,
    style: {
      fill: "#fff",
      opacity: 0.100000001490116
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.5994,
    cy: 145.9862,
    r: 50.5073,
    style: {
      fill: "#fff",
      opacity: 0.100000001490116
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M219.4232,54.874c98.126,8.2179,226.0743,229.7868,188.7895,354.9151-21.8668,73.3914-98.5344,57.15-177.61,37.4-92.5784-23.0792-69.1768,33.9214-128.3848,38.6152-90.03,7.1532-91.8743-67.9927-54.5895-193.0761S130.2241,47.4059,219.4232,54.874Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      opacity: 0.8500000238418579,
      isolation: "isolate",
      fill: "url(#e6f5d0d2-f9bc-4861-b6bc-898f5dd78963)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.4561,135.1186c7.4063,80.0648-61.2918,27.698-177.4126,290.3865-60.3907,136.4655-164.4446,29.9175-236.2967-64.4837C-35.6426,213.4138,10.5691,153.1291,161.9753,81.9571,258.3976,36.6386,480.5858,28.7056,490.4561,135.1186Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#4c9aff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.9703,
    y: 154.3504,
    width: 235.7048,
    height: 324.1045,
    rx: 26.4024,
    style: {
      fill: "#dfe1e5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.0172,
    y: 158.408,
    width: 235.7048,
    height: 324.1045,
    rx: 26.4024,
    style: {
      fill: "#4c9aff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.0467,
    y: 352.2355,
    width: 82.5372,
    height: 20.4699,
    style: {
      fill: "#fff",
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.0467,
    y: 312.6529,
    width: 53.6023,
    height: 15.6008,
    style: {
      fill: "#fff",
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.0467,
    y: 388.0683,
    width: 41.2756,
    height: 10.228,
    style: {
      fill: "#fff",
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.0467,
    y: 410.1473,
    width: 50.8739,
    height: 10.228,
    style: {
      fill: "#fff",
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2411,152.0927,174.4085,123.8294A7.7375,7.7375,0,0,0,165.16,129.58L151.504,187.9535l-4.7432,20.302a7.7515,7.7515,0,0,0,5.7366,9.2486L273.33,245.7114a7.7515,7.7515,0,0,0,9.2486-5.7366l2.7283-11.6971,15.6708-66.9784A7.7375,7.7375,0,0,0,295.2411,152.0927Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.0072,
    y: 185.6359,
    width: 139.4836,
    height: 96.1792,
    rx: 7.6955,
    style: {
      fill: "#dfe1e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.0773,199.3568v12.0189a7.7374,7.7374,0,0,1-7.6955,7.6814H173.2751a7.7234,7.7234,0,0,1-7.6954-7.6814V190.514l42.1431-26.3464L238.7984,186.82l27.2839-15.7967Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#4c9aff",
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.0143,
    cy: 204.7906,
    r: 12.9424,
    style: {
      fill: "#e6e9f8",
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "b64395e2-6163-4ae2-9b90-65abfb74a7dd",
    "data-name": " Clipping Path 13",
    points: "208.258 416.437 183.314 380.317 165.497 406.233 208.258 416.437",
    style: {
      fill: "#feefd3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1225,217.62,23.3052,243.536h0l-12.9581-8.9087a15.8736,15.8736,0,0,1-4.0494-21.8667h0a15.8736,15.8736,0,0,1,21.8667-4.0493Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#253858"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1332,
    y: 191.6773,
    width: 31.4232,
    height: 176.7801,
    transform: "translate(-189.0629 271.1053) rotate(-55.6)",
    style: {
      fill: "url(#b0bf78b8-af59-4e2f-8d14-134729af7cfa)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.033 412.874 208.258 416.437 199.35 403.641 193.033 412.874",
    style: {
      fill: "#42526e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.4485,
    y: 185.1514,
    width: 15.7116,
    height: 176.7801,
    transform: "translate(-181.7383 271.946) rotate(-55.6)",
    style: {
      fill: "#fcb123"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.6062,
    y1: 270.8213,
    x2: 5.7888,
    y2: 296.7373,
    style: {
      fill: "none",
      stroke: "#42526e",
      strokeMiterlimit: 10,
      strokeWidth: "1.4700000286102295px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.9513,
    y1: 274.5467,
    x2: 11.296,
    y2: 300.4628,
    style: {
      fill: "none",
      stroke: "#42526e",
      strokeMiterlimit: 10,
      strokeWidth: "1.4700000286102295px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.8339,
    cy: 536.2992,
    rx: 52.804,
    ry: 10.2044,
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate",
      fill: "url(#fac926af-2a44-4a9b-bdec-b860ad2f5d66)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.7088,268.6422a4.3737,4.3737,0,0,1-2.5916,1.62c-1.4578,0-2.1057-1.2958-4.2114-3.4015s-5.9931-4.0494-5.6691-4.8593.3239-.324,2.2676-.4859a37.7594,37.7594,0,0,1,5.3452-.324,5.67,5.67,0,0,1,2.5916,1.2958,4.5351,4.5351,0,0,1,1.2958,2.43Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#72594b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6657,351.0877a17.3333,17.3333,0,0,1,2.2677-5.6691l2.5916.6479,2.1057.324c2.2676.3239,6.641.81,18.6272,1.7817l2.2676,3.0775a39.0348,39.0348,0,0,1,4.6973,11.3383c7.9368,33.043,8.5847,34.1769,8.5847,34.1769,1.1338,6.479,2.2676,12.958,3.2395,19.437,2.1056,12.9581,4.8592,37.4164,6.317,49.8885a5.0207,5.0207,0,0,1-1.4578,2.2676,5.5071,5.5071,0,0,1-2.43.9719c-2.9155.4859-8.2608-15.55-8.2608-15.55a144.6434,144.6434,0,0,1-5.6691-32.5571,47.3,47.3,0,0,1,.6479-8.2607l-10.5283-19.923-8.0988-15.55c.162,12.4722.162,24.9442,0,37.74,0,15.3877-.324,30.6134-.6479,45.6771a3.2387,3.2387,0,0,1-1.4578.81,5.1835,5.1835,0,0,1-2.7536-.162,8.4218,8.4218,0,0,1-3.5634-2.2676,208.6106,208.6106,0,0,1-3.5635-28.3458c-.9719-13.4439.3239-12.4721-.4859-23.3244-1.1339-16.5215-5.5072-40.008-4.3734-47.7828C84.046,358.7006,85.0178,353.8413,85.6657,351.0877Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#72594b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.11,284.03c.81-1.4578,1.9438-3.4015,1.1339-4.5353s-2.1057-.162-5.9931,0-5.9931-.81-8.7467,0a10.5283,10.5283,0,0,0-5.5072,3.8874c-2.5916,3.7254-1.4577,8.4227-1.1338,9.88a16.5211,16.5211,0,0,0,7.1269,9.0706l3.0775,1.7818L97.49,289.6991Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#172b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3912,309.298H100.73a20.4093,20.4093,0,0,1-1.1339-12.796l-6.9649-.324a15.0534,15.0534,0,0,1-.4859,1.62,9.073,9.073,0,0,1-.6479,1.9438,4.3734,4.3734,0,0,1-3.0775,1.2958Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#543e36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9616,407.6172v-.6479c-.4859-6.641-1.4578-14.2538-2.43-21.7047-1.4577-11.0143-2.7536-21.5427-1.9437-26.24.162-1.2958,1.2958-6.317,1.7818-9.0706l.9718-2.7536a14.2566,14.2566,0,0,1,1.4578-3.24l.4859-.81.9719.324,2.43.4859,1.7817.3239h.324c2.1057.324,6.479.81,18.4652,1.7818h.6479l.324.4859a39.3876,39.3876,0,0,1,2.2676,3.24,38.7113,38.7113,0,0,1,4.8593,11.6623c7.2889,29.6415,8.4227,33.6908,8.5847,34.1768h.1619c.486,2.7536.81,5.5072,1.2958,8.2608-3.5635,2.9155-8.9086,3.7254-14.2538,3.4015-2.43-4.8593-5.0212-9.7186-7.6129-14.5778l-5.5071-10.8524c0,8.0988,0,16.0355-.162,23.9723A26.0779,26.0779,0,0,1,86.9616,407.6172Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#0049b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4475,367.6092a18.3021,18.3021,0,0,1-3.7254-7.7748,25.5906,25.5906,0,0,1,.6479-9.8805l.9718-2.7536a14.2566,14.2566,0,0,1,1.4578-3.24l.4859-.81.9719.324,2.43.4859,1.7817.3239h.324c2.1057.324,6.479.81,18.4652,1.7818h.6479l.324.4859a39.3876,39.3876,0,0,1,2.2676,3.24c4.2114,6.641,5.6692,15.2257,7.6129,22.6766s2.9155,11.3383,4.2114,17.0074c.4859,1.2958,4.2113,13.6059,3.0775,14.5778s-8.9087,3.7254-14.2538,3.4015c-2.43-4.8593-5.0213-9.7185-7.6129-14.5778s-5.6692-11.5-10.5284-16.1976A84.3736,84.3736,0,0,1,87.4475,367.6092Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "url(#b03a9b0c-b263-49a5-aaa9-45385bea17ab)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.11,284.03l1.4578,3.7254,4.8593,2.9155c-.324.81-.81,1.4578-1.1339,2.1057l.4859,7.4509a17.0094,17.0094,0,0,1-4.8592,2.43c-.6479.324-.9719.324-6.641.4859-2.5917,0-3.8874.162-4.3734-.6479a2.9156,2.9156,0,0,1-.162-3.0775c.324-.81.81-.81,1.2958-1.62s-.162-2.2676.162-3.5634,1.4578-1.1339,3.0775-2.7536,1.2958-3.0776,3.0775-5.1833A9.3953,9.3953,0,0,1,99.11,284.03Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#72594b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.8994,308.0022a97.346,97.346,0,0,1-27.3739,13.282c0,3.4015,5.5072,31.9092,6.4791,37.2544a83.2492,83.2492,0,0,1-18.1413,3.8874A55.88,55.88,0,0,1,81.13,360.9682c-.3239-7.2889.9719-24.9442-1.4577-34.3388-.4859-2.1056-.9719-4.0494-1.62-5.9931a7.613,7.613,0,0,1,3.0775-8.5847h.162l1.1339-.6479,2.7536-1.62c5.8311-2.7536,16.5215-3.8874,16.5215-3.8874l11.3383-1.4578c4.8593-.81,9.3946-1.62,13.6059-2.7536-1.9437-5.1832-4.0494-10.3664-6.317-15.7117s-4.5353-10.5284-6.803-15.55l5.6691-3.8874c3.5635,5.6691,7.2889,11.8242,11.0144,18.6272A248.822,248.822,0,0,1,140.8994,308.0022Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#2684ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6589,464.4706h8.7466c-.162-1.4578-.162-3.0775-.3239-4.6973a18.6284,18.6284,0,0,1,.1619-3.0775,24.4612,24.4612,0,0,0-8.4227,0,25.1063,25.1063,0,0,1-.162,7.7748Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#dfe1e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.2372,470.95h8.7467c0-1.62-1.4578-6.317-1.62-7.9368l-4.6973-.4859-4.3733-.6479c.3239,1.4578.81,2.9156,1.1338,4.5353S128.9132,469.4919,129.2372,470.95Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#dfe1e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba9aa09b-b683-4ffc-afac-11a2c4a2aa24",
    "data-name": " Path 6",
    d: "M98.6238,463.8227h0c.162.162.6479-1.2958,1.2958-1.62s0,3.24,2.9155,5.6691a11.66,11.66,0,0,0,3.4015,1.9437,1.296,1.296,0,0,1,.6479,1.1339v.9718H90.0391a23.1615,23.1615,0,0,1,1.4578-8.0987Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#42526e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b0627a76-22f5-42df-b5ae-7bc1a5830bba",
    "data-name": " Path 7",
    d: "M136.2021,470.3017h0c.162.162.6479-1.2958,1.2958-1.62s3.24,3.0775,6.9649,5.5071a14.5775,14.5775,0,0,0,4.5353,2.1057.9719.9719,0,0,1,.81.9719v1.1338H127.6174a23.1643,23.1643,0,0,1,1.4578-8.0988Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#42526e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.078 373.752 461.996 376.766 461.996 368.226 408.078 364.877 408.078 373.752",
    style: {
      fill: "#b2d4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b5122374-a877-4c6b-9507-d25502933767",
    "data-name": " Path 4",
    d: "M418.0271,301.617a117.0439,117.0439,0,0,0,6.53,31.48,47.3873,47.3873,0,0,0,19.9262,7.0328,29.974,29.974,0,0,0,10.8841-.67c5.3583-1.507,12.2236-5.1909,11.8888-8.0375s-8.3724-4.5211-13.5633-4.5211a22.7728,22.7728,0,0,0-4.8559.5024,42.867,42.867,0,0,1-17.2471-2.0094c-2.6792-7.7026-5.3583-15.5726-8.2049-23.4426Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#00a3bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.0564,375.1264a24.784,24.784,0,0,0-2.1768-5.8607l-2.6792.67-2.3443.3349c-2.3442.3349-6.8653.8372-19.0889,1.8419l-2.3443,3.1815a42.3657,42.3657,0,0,0-4.856,11.7213c-8.2049,34.1593-14.4,60.616-17.5819,89.4169l7.3676,2.0094a32.475,32.475,0,0,0,1.842-4.0187,119.8893,119.8893,0,0,0,5.8606-16.41c3.6839-11.5539,4.5211-12.7261,5.1909-17.2471a75.671,75.671,0,0,0,.3349-8.7073,67.3151,67.3151,0,0,0,14.7354-26.6241c-.5024,7.5351-.67,15.4051-.8373,23.4426a371.74,371.74,0,0,0,2.3443,45.2108,7.8676,7.8676,0,0,0,2.5117,1.0047,5.5252,5.5252,0,0,0,2.8466-.3349c1.507-.5023,3.1815-.8372,3.6839-2.1768a3.6843,3.6843,0,0,0-1.0047-3.1815,121.7349,121.7349,0,0,0,3.1815-34.829,193.4178,193.4178,0,0,0,4.0187-19.5914s2.6792-18.9215,1.0047-30.81C461.5634,381.8243,460.3912,376.8009,460.0564,375.1264Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#008da6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.561,488.9906l6.53-2.1768a18.4192,18.4192,0,0,0,12.8935-15.2377c.1675-1.1722,1.0047-6.5305,1.507-8.8747a18.0847,18.0847,0,0,1,5.1909-.1675,15.2384,15.2384,0,0,1,6.6979,3.014,76.5266,76.5266,0,0,0-3.6839,10.3818,68.6523,68.6523,0,0,0-1.6744,11.5539A31.2838,31.2838,0,0,0,416.8549,491h-6.53l-1.0047-1.1722L407.4778,491H390.9006Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#172b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.87,464.3758a10.8843,10.8843,0,0,0-11.8888,0,27.9623,27.9623,0,0,1,.8372,5.1909c.335,3.8513,1.6745,10.3818.335,11.5539l-4.856,3.1815-1.1722,2.5117a17.0805,17.0805,0,0,1,7.2,1.0047l2.8466,1.34a3.6838,3.6838,0,0,0,3.5164-.1674,2.8463,2.8463,0,0,0,1.1721-2.1768Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#172b4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b8bc6443-0dc7-4a3b-89d6-9fccf6cbe418",
    "data-name": " Path 9",
    d: "M225.4626,216.5537l-2.0094-.8372,4.1862-10.0469,2.6792,1.1722a21.266,21.266,0,0,0,14.7353.67h.67a21.2653,21.2653,0,0,1,14.7353.8372L440.8,283.7a16.5773,16.5773,0,0,1,8.8747,21.6007h0a16.5772,16.5772,0,0,1-21.6009,9.1112q-.0838-.034-.1673-.069L248.4029,238.9916a21.0982,21.0982,0,0,1-11.5539-11.2189h0A21.9357,21.9357,0,0,0,225.4626,216.5537Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.5059,248.3687c8.7073-1.8419,20.2612-5.1908,29.1359-7.5351s16.9121-4.6885,23.61-6.363l14.0656,5.8607c-10.2143,1.8419-25.1171,6.0281-35.3314,8.8747l-17.7494,4.8559Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#ffe380"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.2261,262.0994c-47.0527,11.0515-58.774,9.0422-61.6206,2.1768s4.3536-12.3911,11.5538-18.7541l3.349-3.014,8.7073,3.6838c-1.6745,1.8419-4.0188,3.8513-6.1956,5.8607a71.3285,71.3285,0,0,0-8.7073,8.7072c2.6792.67,11.219,1.34,38.8478-4.521Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#ffe380"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.9673,223.754c-17.4145,11.2189-26.9591,18.2517-32.15,22.6053l-9.0422-3.6838c5.3584-5.0234,14.9028-12.2237,31.3127-22.94Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#ffe380"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.7319,207.5116l4.6885-4.856a2.1767,2.1767,0,0,1,2.5117-.67l8.7073,3.6838-4.1862,10.0469-11.0515-4.6886a2.0094,2.0094,0,0,1-1.1722-2.8466C211.23,207.8465,211.397,207.679,211.7319,207.5116Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#ff8b00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.2449,295.4214l-.8373-3.014-2.0094-3.5164a30.8153,30.8153,0,0,1-.8372-8.7073,32.4946,32.4946,0,0,1,.3349-4.0187l1.34-.5024,1.3395-.5023H393.58c1.842.3349,2.8467,2.5117,3.349,4.3536s-.1675,3.1815,1.0047,4.1862l.3349.3349a4.1862,4.1862,0,0,1,1.507-3.1815l1.6745-.3349a3.18,3.18,0,0,0-.3349,1.1721,19.588,19.588,0,0,0-.67,4.3537l-.67,4.1862.5023,3.014Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#b19177"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.2191,332.93H447.4978a22.4382,22.4382,0,0,0,1.34-13.2284l7.0328-.3349a10.389,10.389,0,0,1,.5023,1.6745,3.5162,3.5162,0,0,0,.67,2.0094c.8372.8372,2.3442.3349,2.8466.1674Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#8c715d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.0048,308.8172a13.396,13.396,0,0,1-5.0234,7.3677l1.34,1.6745c.3349,2.3442.5023,4.6885.8372,7.0328a16.7468,16.7468,0,0,0,4.856,1.6744c2.1768.3349,5.0234.8373,6.3629-.67a5.1907,5.1907,0,0,0,.8373-3.5164,14.7365,14.7365,0,0,0-.3349-2.8466,13.2307,13.2307,0,0,0-2.1768-4.3536,17.5817,17.5817,0,0,0-4.0188-4.6885Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#b19177"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.6219,332.7622a93.1,93.1,0,0,0,31.815,13.2283,96.9521,96.9521,0,0,1-5.8607,28.2986,44.0389,44.0389,0,0,0,31.9825,2.3443,71.8368,71.8368,0,0,1,3.6838-25.2846,75.8607,75.8607,0,0,1,5.3584-11.8888,39.7015,39.7015,0,0,0-5.0234-3.8513l-1.1722-.8372-2.8466-1.507c-6.0281-3.0141-16.9122-4.0187-16.9122-4.0187-14.9028-1.34-14.4005-1.0047-17.4145-1.507a64.97,64.97,0,0,1-15.74-4.5211c-3.5164-10.5492-7.0328-21.0984-10.3817-31.815l-8.3724,2.1768c1.34,6.8653,3.014,14.233,5.1909,21.7682S400.6125,327.4039,402.6219,332.7622Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#00b8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.2566,316.1849c2.5117,7.87,10.3817,7.3677,11.5538,13.3958s-3.8512,13.8981-10.3817,14.0656c-3.6839,0-7.3677-2.8466-9.5445-6.8654a7.0332,7.0332,0,0,1-3.6839.5024,7.87,7.87,0,0,1-4.6885-4.0188c-2.1768-3.8513-.3349-10.3817,4.3536-16.2423a36.8374,36.8374,0,0,1-8.0374-8.8748,10.0468,10.0468,0,0,1,11.0515-6.0281,11.89,11.89,0,0,1,6.8654,3.5164C467.424,308.9847,465.75,311.6638,467.2566,316.1849Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "#171f40"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 419.9053,
    cy: 551.3603,
    rx: 52.804,
    ry: 10.2044,
    style: {
      opacity: 0.10000000149011612,
      isolation: "isolate",
      fill: "url(#bbe26835-66db-4318-9601-eb6f885c3df4)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.674 197.062 409.674 226.262 434.274 216.462 415.674 197.062",
    style: {
      fill: "url(#f3c99759-2acd-44d1-9c2c-50366d998842)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.274 162.062 440.874 156.662 444.874 180.162 427.174 185.162 423.274 162.062",
    style: {
      fill: "#00c7e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.96,154.0043c-3.2-4.4-3.2-11.3,0-15.4s8.7-3.9,12,.5,3.4,11.4,0,15.5S453.26,158.4043,449.96,154.0043Z",
    transform: "translate(-3.5865 62.7579)",
    style: {
      fill: "none",
      stroke: "#ff991f",
      strokeMiterlimit: 10,
      strokeWidth: "3.4100000858306885px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.9135,
    cy: 172.2579,
    r: 14.5,
    style: {
      fill: "url(#f9bf74a5-47fb-46c2-82a4-b5cd40128223)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.9135,
    cy: 145.7579,
    rx: 9.5,
    ry: 6,
    style: {
      fill: "url(#af8bb7c0-75d1-443e-bf15-5ca0edf77010)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCms);
export default __webpack_public_path__ + "static/media/cms.d13e9e785200aaf3db66c22d1681f52f.svg";
export { ForwardRef as ReactComponent };